module.exports = __webpack_public_path__ + "static/media/logo.f02a76a0.svg";